import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import {
  faCircleExclamation,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import StatusChip from '../../../../../Shared/StatusChip';
import { parseDateToLocal } from '../../../../../../shared/utils';
import CustomerCareDTable from '../../../../../Shared/CustomerCareDTable';
import NoDataCard from '../../../../../Dashboard/detailPanel/NoDataCard';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCustomerIssues } from '../../../../../../store/customers/actionCreators';
import LoadingSpinner from '../../../../../Shared/LoadingSpinner';
import {
  customError,
  warningBg,
  warningYellow,
} from '../../../../../../mainTheme';

const getIssueStatusConfig = (issue: any) => {
  if (issue.severity === 'high') {
    return {
      icon: faTriangleExclamation,
      color: customError,
      text: issue.title,
      backgroundColor: '#FCEFEE',
    };
  }
  return {
    icon: faCircleExclamation,
    color: warningYellow,
    text: issue.title,
    backgroundColor: warningBg,
  };
};

const IssuesDetailsPanel = ({ customerId }: { customerId: number }) => {
  const dispatch = useDispatch();
  const { customerIssues, customerIssuesLoading } = useSelector(
    (state: any) => state.customers,
  );

  useEffect(() => {
    if (!customerIssues || customerIssues.customerId !== customerId) {
      dispatch(fetchCustomerIssues(customerId));
    }
  }, [dispatch, customerId]);

  const columns = [
    {
      field: 'issue',
      headerName: 'Issue',
      flex: 2,
      renderCell: (params: any) => {
        const config = getIssueStatusConfig(params.row);
        return (
          <StatusChip
            icon={config.icon}
            iconColor={config.color}
            labelText={config.text}
            backgroundColor={config.backgroundColor}
            conditionalValue={params.row.severity}
          />
        );
      },
    },
    {
      field: 'created_at',
      headerName: 'Event time',
      flex: 2,
      renderCell: (params: any) => (
        <span>
          {params.row.created_at
            ? parseDateToLocal(params.row.created_at, 'yyyy-MM-dd HH:mm:ss')
            : 'N/A'}
        </span>
      ),
    },
    {
      field: 'resolved_at',
      headerName: 'Resolved time',
      flex: 2,
      renderCell: (params: any) => (
        <span>
          {params.row.resolved_at
            ? parseDateToLocal(params.row.resolved_at, 'yyyy-MM-dd HH:mm:ss')
            : 'N/A'}
        </span>
      ),
    },
  ];

  const rows = Array.isArray(customerIssues)
    ? customerIssues
    : Object.values(customerIssues).filter(
        (item: any) => typeof item === 'object' && item.id,
      );

  if (customerIssuesLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {rows.length ? (
        <Box p={2}>
          <CustomerCareDTable
            rows={rows}
            columns={columns}
            loading={customerIssuesLoading}
            pageSize={4}
            defaultSortField="issue"
            defaultSortDirection="desc"
            hideViewAllButton
          />
        </Box>
      ) : (
        <NoDataCard />
      )}
    </>
  );
};

export default IssuesDetailsPanel;
